import { useContext } from "react";
import { useSelector } from "react-redux";
import { Tag } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  tags: Tag[];
  projectUuid: string;
  isDirty: boolean;
  retrieveProjectResourcesTags(
    request: Boundaries["retrieveProjectResourcesTags"]["request"],
  ): void;
}

function useRetrieveProjectResourcesTags(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveProjectResourcesTagsRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveProjectResourcesTagsRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveProjectResourcesTagsRequestFailure,
    ),
    tags: useSelector(selector.getProjectResourcesTags),
    projectUuid: useSelector(selector.getProjectResourcesTagsProjectUuid),
    isDirty: useSelector(selector.areProjectResourcesTagsDirty),
    retrieveProjectResourcesTags: core.retrieveProjectResourcesTags,
  };
}

export { useRetrieveProjectResourcesTags };
